// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_btn__o6irO {
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 0.5rem;
  padding: 1rem 1.2rem;
  font-size: var(--text-base);
  font-weight: 500;
}

.Button_btn__o6irO:disabled,
.Button_btn__o6irO:disabled:hover,
.Button_btn__o6irO:disabled:focus {
  background-color: var(--disabled);
  cursor: not-allowed;
  color: #fff;
}

.Button_btn__icon__JG6eA {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: middle;
  margin-inline-end: 1.2rem;
}

.Button_btn__animation__sJMDg {
  display: inline-block;
  padding-inline-start: 1.2rem;
  vertical-align: middle;
}

.Button_btn__loading__pqZH6 {
  width: 100%;
  height: 100%;
  scale: 3.5;
}

.Button_btn--primary__WgPG\\+ {
  background-color: var(--primary-color);
  transition: background-color 0.3s ease-out;
  color: #fff;
}

.Button_btn--primary__WgPG\\+:hover {
  background-color: var(--blue-extra-dark);
}

.Button_btn--secondary__kB9et {
  background-color: #fff;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".btn {\n  cursor: pointer;\n  border: none;\n  outline: none;\n  border-radius: 0.5rem;\n  padding: 1rem 1.2rem;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.btn:disabled,\n.btn:disabled:hover,\n.btn:disabled:focus {\n  background-color: var(--disabled);\n  cursor: not-allowed;\n  color: #fff;\n}\n\n.btn__icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: middle;\n  margin-inline-end: 1.2rem;\n}\n\n.btn__animation {\n  display: inline-block;\n  padding-inline-start: 1.2rem;\n  vertical-align: middle;\n}\n\n.btn__loading {\n  width: 100%;\n  height: 100%;\n  scale: 3.5;\n}\n\n.btn--primary {\n  background-color: var(--primary-color);\n  transition: background-color 0.3s ease-out;\n  color: #fff;\n}\n\n.btn--primary:hover {\n  background-color: var(--blue-extra-dark);\n}\n\n.btn--secondary {\n  background-color: #fff;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__o6irO`,
	"btn__icon": `Button_btn__icon__JG6eA`,
	"btn__animation": `Button_btn__animation__sJMDg`,
	"btn__loading": `Button_btn__loading__pqZH6`,
	"btn--primary": `Button_btn--primary__WgPG+`,
	"btn--secondary": `Button_btn--secondary__kB9et`
};
export default ___CSS_LOADER_EXPORT___;
